import { get } from '..';

const getClientDetails = () => get('button/client');

export default getClientDetails;
